import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Divider, Typography, Box } from '@material-ui/core';

import useProducts from 'utils/hooks/useProducts';
import Icon from 'components/Icon';

import { Configuration } from '../types';
import { getTipProductId } from '../rdx/reducer';

import { ProductSearch } from './ProductSearch';

type TipConfProps = {
  save: (prodId: Configuration['tipProductId']) => void;
};

export const TipProductConfig: FC<TipConfProps> = ({ save }) => {
  const { t } = useTranslation('customerDisplay');
  const tipId = useSelector(getTipProductId);

  const [tipProductId, setTipProductId] = useState(tipId);
  const {
    products: [tipProduct],
  } = useProducts({ productID: tipProductId });

  function resetConfig() {
    setTipProductId(0);
    save(0);
  }

  return (
    <div style={{ marginTop: '10px', overflowX: 'auto' }}>
      <Typography variant="h5">{t('tipForm.title')}</Typography>
      {tipProductId === 0 || !tipProductId ? (
        <Typography variant="body1" style={{ fontWeight: 'bold' }}>
          {t('tipForm.noProduct')}
        </Typography>
      ) : (
        <Box display="flex" alignItems="center" marginTop={2}>
          <Typography variant="body1" style={{ fontWeight: 'bold' }}>
            {t('tipForm.product', {
              name: tipProduct?.name,
            })}
          </Typography>
          <Icon
            key="icon_trash_alt"
            name="icon_trash_alt"
            title={t('productsTable.actions.clear')}
            action={() => resetConfig()}
            data-testid="clear-tip-product"
            style={{
              color: 'red',
            }}
          />
        </Box>
      )}
      <ProductSearch
        handleProductSelect={(prodId: number) => {
          setTipProductId(prodId);
          save(prodId);
        }}
        productType="tip"
        selectedProductId={tipProductId}
      />
      <Divider />
    </div>
  );
};
